var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3616 0.0078125H25.066H13.7454L14.9149 7.64067H21.2613L12.802 24.6294H11.8196L8.27218 0.0078125H0L5.21592 34.4843H16.5444L33.9775 0.0078125H33.3616Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4345 0L65.1948 7.63286H76.7884L72.5314 34.4687H80.4138L84.6707 7.63286H95.5235L96.771 0H66.4345Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7599 26.8671L70.5203 34.4999H51.021L54.3034 13.9715L56.5254 0.03125H64.4077L60.1508 26.8671H71.7599Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5305 34.4999H27.8338H39.1545L37.9772 26.8671H31.6308L40.0901 9.87833H41.0802L44.6199 34.4999H52.8999L47.6762 0.03125H36.3477L18.9146 34.4999H19.5305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValtIcon);
export default __webpack_public_path__ + "static/media/valt-icon.123698c8d9aa123c1fa02a8ada55c521.svg";
export { ForwardRef as ReactComponent };